import React, { useEffect, useRef, useState } from 'react';
import JsonButton from './JsonButton';
import { OutSideClicker } from './OutSideClicker';
import { Col, Row } from 'reactstrap';
import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'
import { toast } from "react-toastify";


interface JsonTooltipProps {
  jsonData: object;
  disabled?:boolean;
  isVisible:any;
  field:any;
  onSaveJson:any;
}


const JsonTooltip = (props:JsonTooltipProps) => {
  // const {jsonData} = props
  const jsonData:any = props.jsonData
  const keys =  Object?.keys(jsonData)
  const [showTooltip, setShowTooltip] = useState(false);
   const [editModal, setEditModal] = useState(false)

  const handleToggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

 useEffect(()=>{
    if(!props.isVisible){
      setShowTooltip(false);
    }
 }, [props.isVisible])
  
 

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(jsonData, null, 2));
     toast.success('JSON copied to clipboard')
    
  };

  const handleEdit = (e:any) => {
    
    
    props.onSaveJson(e.src,props.field)
   // setEditModal(!editModal)
  };

 

  return (
    <div className="json-tooltip-container">
      <button disabled={props?.disabled} className={`json-button ${showTooltip ? "json-edit" : ""}`}onClick={handleToggleTooltip}>{'{ } JSON'}</button>
      {showTooltip && (
        <div className="json-tooltip">
          {/* <pre>{JSON.stringify(jsonData, null, 2)}</pre> */}
          <JsonView src={jsonData} editable={{edit:true, add:false, delete:false}} onEdit = {handleEdit} />
          {/* {
         keys.map(row=>(
              <Row>
                <Col>{row}</Col>
                <Col>{jsonData[row]}</Col>
              </Row>
            ))
          } */}
          <div className="json-tooltip-actions">
            <button onClick={handleCopy}>Copy</button>
          </div>
          
        </div>
      )}
      <>{
        editModal &&<>
        
    
        </>

      }
      </>
    </div>
  );
};

export default JsonTooltip;
